// ============================================
// SICHERHEIT: Konstanten & Validierung
// ============================================
const ERLAUBTE_TYPEN = ['image/jpeg', 'image/png', 'image/webp'];
const MAX_DATEIGROESSE = 10 * 1024 * 1024;
const MAX_REQUESTS_PRO_MINUTE = 3;
const TIMEOUT_MS = 120000;

const requestZeiten = [];
function rateLimitPruefen() {
  const jetzt = Date.now();
  const vor60sek = jetzt - 60000;
  const recent = requestZeiten.filter(t => t > vor60sek);
  requestZeiten.length = 0;
  requestZeiten.push(...recent);
  if (requestZeiten.length >= MAX_REQUESTS_PRO_MINUTE) {
    throw new Error('Bitte warte kurz bevor du erneut generierst.');
  }
  requestZeiten.push(jetzt);
}

function dateiValidieren(file) {
  if (!file) throw new Error('Kein Bild ausgewählt.');
  if (!ERLAUBTE_TYPEN.includes(file.type)) {
    throw new Error('Nur JPG, PNG oder WebP erlaubt.');
  }
  if (file.size > MAX_DATEIGROESSE) {
    throw new Error('Bild ist zu groß (max. 10MB).');
  }
}

function webhookUrlValidieren(url) {
  if (!url || typeof url !== 'string') throw new Error('Ungültige Webhook-URL.');
  if (!url.startsWith('https://')) throw new Error('Unsichere Webhook-URL.');
}

// ============================================
// Upload Inputs initialisieren
// ============================================
const btn = document.getElementById('ki-generieren-btn');
const neuBtn = document.getElementById('ki-neu-btn');
const maxPersonen = window.kiMaxPersonen || 1;
const hochgeladeneFiles = {};

function allesFoechsHochgeladen() {
  for (let i = 1; i <= maxPersonen; i++) {
    if (!hochgeladeneFiles[i]) return false;
  }
  return true;
}

function btnStatusAktualisieren() {
  btn.disabled = !allesFoechsHochgeladen();
  const hinweis = document.getElementById('ki-btn-hinweis');
  if (hinweis) hinweis.style.display = btn.disabled ? 'block' : 'none';
}

for (let i = 1; i <= maxPersonen; i++) {
  const input = document.getElementById(`ki-foto-input-${i}`);
  if (!input) continue;

  input.addEventListener('change', () => {
    const file = input.files[0];
    if (!file) return;

    try {
      dateiValidieren(file);
    } catch(e) {
      alert(e.message);
      input.value = '';
      return;
    }

    hochgeladeneFiles[i] = file;

    const preview = document.getElementById(`ki-foto-preview-${i}`);
    if (preview) {
      preview.src = URL.createObjectURL(file);
      preview.style.display = 'block';
    }

    btnStatusAktualisieren();
  });
}

// ============================================
// Ladeanimation
// ============================================
function ladeAnimationZeigen() {
  const loading = document.getElementById('ki-loading');
  loading.innerHTML = `
    <div style="display:flex;flex-direction:column;align-items:center;gap:16px;padding:30px;">
      <video
        src="${window.kiLadeAnimation}"
        autoplay loop muted playsinline
        style="width:220px;height:220px;object-fit:contain;"
      ></video>
      <p style="font-size:15px;color:#666;margin:0;">KI erstellt dein Design<span class="ki-dot-anim"></span></p>
      <p style="font-size:13px;color:#999;margin:-8px 0 0;">Das dauert ca. 20–40 Sekunden</p>
      <style>
        .ki-dot-anim::after{content:'';animation:ki-dot-cycle 1.5s steps(4,end) infinite;}
        @keyframes ki-dot-cycle{0%{content:''}25%{content:'.'}50%{content:'..'}75%{content:'...'}100%{content:''}}
      </style>
    </div>
  `;
  loading.style.display = 'block';
}

function ladeAnimationVerstecken() {
  const loading = document.getElementById('ki-loading');
  loading.style.display = 'none';
  loading.innerHTML = '';
}

// ============================================
// Hauptfunktion: Generieren
// ============================================
async function generieren() {
  for (let i = 1; i <= maxPersonen; i++) {
    try {
      dateiValidieren(hochgeladeneFiles[i]);
    } catch(e) {
      alert(maxPersonen > 1 ? `Person ${i}: ${e.message}` : e.message);
      return;
    }
  }

  try {
    webhookUrlValidieren(window.kiWebhookUrl);
    rateLimitPruefen();
  } catch(e) {
    alert(e.message);
    return;
  }

  btn.disabled = true;
  neuBtn && (neuBtn.disabled = true);
  ladeAnimationZeigen();
  document.getElementById('ki-mockup-container').style.display = 'none';
  document.getElementById('ki-ergebnis-bereich').style.display = 'none';

  const formData = new FormData();

  // Alle Fotos anhängen
  for (let i = 1; i <= maxPersonen; i++) {
    formData.append(`bild_${i}`, hochgeladeneFiles[i]);
  }

  // Namen anhängen falls aktiviert
  if (window.kiHatNamen) {
    const seiten = ['1. von links', '2. von links', '3. von links', '4. von links', '5. von links'];
    for (let i = 1; i <= maxPersonen; i++) {
      const nameInput = document.getElementById(`ki-name-${i}`);
      const name = nameInput ? String(nameInput.value).trim().slice(0, 20) : '';
      formData.append(`name_${i}`, name);
      formData.append(`name_${i}_position`, seiten[i - 1] || `${i}. von links`);
    }
  }

  // Textfeld anhängen falls aktiviert
  if (window.kiHatTextfeld) {
    const textInput = document.getElementById('ki-custom-text');
    formData.append('custom_text', textInput ? String(textInput.value).slice(0, 40) : '');
  }

  formData.append('produkt_id', String(window.kiProduktId || ''));
  formData.append('stil_prompt', String(window.kiStilPrompt || ''));
  formData.append('farbe', String(window.kiGewahlteFarbe || 'Weiß'));
  formData.append('template_url', String(window.kiTemplateDesign || ''));
  formData.append('max_personen', String(maxPersonen));

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), TIMEOUT_MS);

  try {
    const response = await fetch(window.kiWebhookUrl, {
      method: 'POST',
      body: formData,
      signal: controller.signal
    });

    clearTimeout(timeout);

    if (!response.ok) throw new Error('Server Fehler: ' + response.status);

    const contentType = response.headers.get('content-type') || '';
    if (!contentType.startsWith('image/')) {
      throw new Error('Ungültige Antwort vom Server.');
    }

    const blob = await response.blob();
    if (blob.size === 0) throw new Error('Leeres Bild erhalten.');

    const bildUrl = URL.createObjectURL(blob);
    const onedriveId = response.headers.get('X-OneDrive-ID') || '';
    const dateiname = response.headers.get('X-Dateiname') || '';

    document.getElementById('ki-design-layer').src = bildUrl;
    document.getElementById('ki-mockup-container').style.display = 'block';
    document.getElementById('ki-ergebnis-bereich').style.display = 'block';

    window.kiGeneriertesDesign = dateiname;
    window.kiOnedriveId = onedriveId;
    window.kiGeneriertesBildUrl = bildUrl;

  } catch(e) {
    clearTimeout(timeout);
    if (e.name === 'AbortError') {
      alert('Zeitüberschreitung – bitte nochmal versuchen.');
    } else {
      alert('Fehler beim Generieren: ' + e.message);
    }
  } finally {
    ladeAnimationVerstecken();
    btn.disabled = false;
    neuBtn && (neuBtn.disabled = false);
  }
}

// ============================================
// Event Listener
// ============================================
btn.addEventListener('click', generieren);
neuBtn && neuBtn.addEventListener('click', generieren);

document.getElementById('ki-kaufen-btn').addEventListener('click', () => {
  if (!window.kiGeneriertesDesign) {
    alert('Bitte erst ein Design generieren.');
    return;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: window.kiVariantId,
      quantity: 1,
      properties: {
        '_Design-Datei': window.kiGeneriertesDesign || '',
        '_Design-ID': window.kiOnedriveId || ''
      }
    })
  })
  .then(res => {
    if (!res.ok) throw new Error('Warenkorb Fehler');
    window.location.href = '/cart';
  })
  .catch(() => {
    alert('Fehler beim Hinzufügen zum Warenkorb.');
  });
});

btnStatusAktualisieren();